import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Survey from './../../../commonComponents/surveyView';
import SurveyCompletedScreen from './../../../commonComponents/surveyView/surveyCompleted';
import Attachment from './../../../commonComponents/attachmentView';
import DisplayActorEmails from './../displayActorEmails';
import ReplyOptions from '../replyOptions';
import getLabel from './../../../../utils/labels'
import mailArrow from '../../../../globals/images/mailarrow.svg';
import assessmentIcon from '../../../../globals/images/assessment-icon.svg';
import starredIcon from '../../../../globals/images/star_selected.png';
import unselectedIcon from './../../../../globals/images/star_unselected.svg';
import attachementIcon from '../../../../globals/images/attachment.svg';
import styles from './simpleMail.module.scss';

class SimpleMail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSurveyOpen: false,
            isAttachmentOpen: false,
            isMailStarred: this.getMailStarredFlag(props.actionThread),
            isArrowDown: true,
            callCompleted: false
        }
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            isMailStarred: this.getMailStarredFlag(nextProps.actionThread)
        })
    }

    getMailStarredFlag = (actionThread) => {
        return actionThread.some((action) => (action.type === "starred" && action.status === true));
    }

    checkSurveyTerminatedFlag = () => {
        return this.props.actionThread.some(action => action.type === "call_terminated")
    }

    getFirstNamesOfActors = () => {
        let array = this.getToActors(true);
        let actorNames = []
        if (array.length >= 2) {
            return getLabel('label_all_text')
        } else {
            array.map(item => {
                if (item.details.is_group_email === 0) {
                    actorNames.push(item.details.first_name)
                } else {
                    actorNames.push(getLabel('label_all_text'))
                }
            })
            return actorNames.join(", ");
        }
    }

    getGreetingText = (composeBody) => {
        return <div className={styles.salutaion}>Hi {this.getFirstNamesOfActors(composeBody)},</div>
    };

    getEmailSignature = () => {
        const fromActor = this.getFromActor();
        return (
            <div
                style={{
                    margin: '10px 0',
                    float: 'left',
                    lineHeight: '22px'
                }}
            >
                {getLabel('label_regards')},<br />{fromActor.first_name} {fromActor.last_name}<br />{fromActor.role}<br />{fromActor.company}
            </div>
        )
    }

    getBody = () => {
        return this.props.body.map((para, key) => <div className={styles['body-text']} key={key} dangerouslySetInnerHTML={{ __html: para }} />)
    }

    openAttachment = () => {
        this.setState({ isAttachmentOpen: true })
    }

    closeAttachment = () => {
        this.setState({ isAttachmentOpen: false })
    }

    getAttachment = () => {
        return <div className={styles['attachemnt-container']} onClick={() => { this.openAttachment() }}>
            <div className={styles['attchment-image']}>
                <p>{getLabel('label_pdf_tag')}</p>
            </div>
            <div className={styles.title}>
                {this.props.attachments[1]}
            </div>
        </div>
    }

    getSurveyButton = () => {
        return (
            <div className={styles['button-container']}>
                <div className={styles['survey-button']} onClick={this.openSurvey}>
                    <img src={assessmentIcon} className={styles['icon']} />
                    {getLabel('label_survey_start_button')}
                </div>
            </div>
        );
    }

    getCallButton = () => {
        return <div className={styles['button-container']}>
            <div className={styles['survey-button']} onClick={this.openCall}>
                <img src={assessmentIcon} className={styles['icon']} />
                {getLabel('label_call_start_button')}
            </div>
        </div>
    }

    openSurvey = () => {
        this.setState({
            isSurveyOpen: true
        })
    }

    closeSurvey = () => {
        this.setState({
            isSurveyOpen: false
        })
    }

    openCall = () => {
        if (this.props.isCallCompleted) {
            this.openCallCompletedAlert()
        } else {
            this.props.startCall({
                primaryMailId: this.props.nextMailId
            })
        }
    }

    openCallCompletedAlert = () => {
        this.setState({
            callCompleted: true
        })
    }

    closeCallCompletedAlert = () => {
        this.setState({
            callCompleted: false
        })
    }

    getFromActor = () => {
        const { from, actors } = this.props;

        let actorDetails = actors.clients.find(actor => actor.id === from) || actors.inActors.find(actor => actor.id === from);
        if (actorDetails) {
            return actorDetails
        }
        return from;
    }

    getToActors = (returnArray = false) => {
        let { to, cc, actors } = this.props;
        let temp, actorArray = [];

        if (!to) {
            to = []
        }
        if (!cc) {
            cc = []
        }

        to = [...to, ...cc];
        if (to) {
            let actorDetails = to.map((toActor) => {
                temp = actors.clients.find(actor => actor.id === toActor) || actors.inActors.find(actor => actor.id === toActor)
                if (temp) {
                    actorArray.push(temp.first_name + ' ' + temp.last_name)
                } else {
                    actorArray.push(toActor);
                }

                if (cc.includes(toActor)) {
                    return { type: 'cc', details: temp }
                } else {
                    return { type: 'to', details: temp }
                }
            })

            if (returnArray) {
                return actorDetails
            }

            return actorArray.join(", ");
        }
    }

    getEmailOfAllActors = () => {
        return this.getToActors(true);
    }

    toggleArrow = () => {
        this.setState(prevState => ({
            isArrowDown: !prevState.isArrowDown
        }))
    }

    addMailStarredFlag = () => {
        this.props.addMailStarredFlag(this.props.id);
    }

    removeMailStarredFlag = () => { this.props.removeMailStarredFlag(this.props.id) }

    render() {
        const { match, showReplyOption, actionThread, type, attachments, info,
            survey, displayTime, setSurveyCompleteFlag, showButtons, isHovered, currentActorId } = this.props;
        const { isSurveyOpen, isAttachmentOpen, isMailStarred, isArrowDown, callCompleted } = this.state;

        let fromActor = this.getFromActor();

        let arrowStyle = {
            transform: 'rotate(180deg)',
            marginTop: '-5px'
        }

        return (
            <div className={styles.container}>
                <div className={styles['icon-container']}>
                    <img src={fromActor.gravatar} className={styles.image} />
                </div>
                <div className={styles['content']}>
                    <header className={styles['header']}>
                        <div className={styles["people-container"]} >
                            <div
                                className={styles['from']}
                                style={{ position: 'relative' }}
                                onMouseEnter={() => this.props.setIsHoveredFlag(fromActor.id)}
                                onMouseLeave={() => this.props.removeIsHoveredFlag()}
                                data-tip="React-tooltip"
                            >
                                {`${fromActor.first_name} ${fromActor.last_name}`}
                                {
                                    isHovered && fromActor.id === currentActorId ?
                                        this.props.getActorDetailsOnHover(fromActor)
                                        :
                                        null
                                }
                            </div>
                            <div className={styles['to-list']}>
                                <p> {getLabel('label_to_actors_list')} </p>
                                <p style={{ marginLeft: '4px' }}> {this.getToActors()}</p>
                                <div
                                    className={styles.arrow}
                                    onClick={this.toggleArrow}
                                >
                                    <img src={mailArrow} style={!isArrowDown ? arrowStyle : {}} />
                                    {
                                        !isArrowDown ?
                                            <DisplayActorEmails data={this.getEmailOfAllActors()} />
                                            :
                                            null
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={styles['action-list']}>
                            {
                                attachments ?
                                    <div className={styles.attachment}>
                                        <img src={attachementIcon} />
                                    </div>
                                    : null
                            }
                            {
                                isMailStarred ?
                                    <div className={styles.star} onClick={this.removeMailStarredFlag}>
                                        <img src={starredIcon} />
                                    </div>
                                    :
                                    <div className={styles.star} onClick={this.addMailStarredFlag}>
                                        <img src={unselectedIcon} />
                                    </div>
                            }
                            <div className={styles.timer}>
                                {
                                    displayTime > 0 ?
                                        <div>{("0" + displayTime).slice(-2)} {getLabel('label_time_received_at')}</div>
                                        :
                                        <div>{getLabel('label_just_now')}</div>
                                }
                            </div>
                        </div>
                    </header>

                    <div className={styles.body}>
                        {this.getGreetingText()}
                        {this.getBody()}
                        {this.getEmailSignature()}
                    </div>

                    {attachments ? this.getAttachment() : null}
                    {type === "survey" ? this.getSurveyButton() : null}
                    {type === "voice_mail" ? this.getCallButton() : null}
                    {
                        showReplyOption && showButtons ?
                            <ReplyOptions
                                match={match}
                                tutorial={this.props.tutorial}
                                startTutorial={this.props.startTutorial}
                                stopTutorial={this.props.stopTutorial}
                                addStepsToTutorial={this.props.addStepsToTutorial}
                                updateStepNumber={this.props.updateStepNumber}
                            />
                            :
                            null
                    }
                </div>
                {
                    isSurveyOpen && !this.checkSurveyTerminatedFlag() ?
                        <Survey
                            primaryMailId={this.props.id}
                            actionThread={actionThread}
                            survey={survey}
                            closeSurvey={this.closeSurvey}
                            getTimeData={this.props.getTimeData}
                            autoSaveSurveyAnswers={this.props.autoSaveSurveyAnswers}
                            setSurveyCompleteFlag={setSurveyCompleteFlag}
                        />
                        :
                        null
                }
                {
                    isSurveyOpen && this.checkSurveyTerminatedFlag() ?
                        <SurveyCompletedScreen closeSurvey={this.closeSurvey} text={getLabel('label_survey_already_submitted')} />
                        : null
                }
                {
                    callCompleted ?
                        <SurveyCompletedScreen closeSurvey={this.closeCallCompletedAlert} text={getLabel('label_call_already_completed')} />
                        :
                        null
                }
                {
                    isAttachmentOpen ?
                        <Attachment src={this.props.attachments[0]} closeAttachment={this.closeAttachment} />
                        : null
                }
            </div>
        )
    }

}
SimpleMail.propTypes = {};

SimpleMail.defaultProps = {};

export default SimpleMail;



// WEBPACK FOOTER //
// /src/components/mailThread/mail/simpleMail/SimpleMail.js